import React from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { ForgotPasswordProps } from "models/propTypes/loginPropTypes";
//#endregion
//#region components
import { ActionLinkButton, Icon, StyledButton, useEnterPressHandler, useMountedState } from "components/common";
import { Grid } from "@mui/material";
import ForgotPasswordFormContainer from "./forms/forgotPasswordFormContainer";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const ForgotPassword: React.FC<ForgotPasswordProps> = (props) => {
  const [isSubmitting, setSubmitting] = React.useState<boolean>(false);
  const formRef = React.useRef<FormHandles>(null);
  const { getMounted } = useMountedState();

  const onSubmitClick = () => {
    setSubmitting(true);
    return (
      (formRef.current && formRef.current.submit().then(() => props.onSubmitSuccess())) ||
      new Promise<void>((resolve) => resolve())
    ).finally(() => {
      getMounted() && setSubmitting(false);
    });
  };

  useEnterPressHandler(onSubmitClick);

  return (
    <>
      <Grid container className={cssExports.topContent}>
        <ActionLinkButton onClick={props.goBack} startIcon={<Icon icon={IconDefinitionConstants.WChevronLeft} />}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.Login)}
        </ActionLinkButton>
      </Grid>
      <Grid container spacing={4}>
        <Grid container item>
          <Grid container spacing={1}>
            <Grid item container className={cssExports.loginHeader}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.RequestPasswordTitle)}
            </Grid>
            <Grid item container className={cssExports.loginMessage}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.RequestPasswordMessage)}
            </Grid>
          </Grid>
        </Grid>
        <Grid item container justifyContent="flex-start" spacing={3}>
          <Grid item container className={cssExports.loginFormContainer} spacing={0}>
            <ForgotPasswordFormContainer ref={formRef} />
          </Grid>
          <Grid item container>
            <StyledButton
              type="submit"
              onClick={onSubmitClick}
              className={cssExports.loginButton}
              isSubmitting={isSubmitting}
              displayType={props.displayType}
            >
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.Send)}
            </StyledButton>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ForgotPassword;
